import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgPicCirclePaymentSsSelected({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 56 56"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <circle cx={28} cy={28} r={28} fill="#56A" opacity={0.88} />
      <rect width={26} height={20} x={15} y={17} fill="#fff" rx={2} />
      <path
        fill="#8F9DD6"
        d="M18 32.35c0-.2.16-.35.35-.35h5.3c.2 0 .35.16.35.35v2.3c0 .2-.16.35-.35.35h-5.3a.35.35 0 01-.35-.35z"
      />
      <path fill="#6A79B4" d="M15 23h26v3H15z" />
      <circle cx={38} cy={37} r={9} fill="#8F9DD6" />
      <path
        fill="#fff"
        d="M36.02 35.82a1 1 0 00-.36-.67q-.32-.24-.88-.24-.38 0-.63.11a1 1 0 00-.4.29.7.7 0 00-.14.42q0 .2.09.34t.25.25.37.18.44.13l.66.15q.47.12.87.29t.69.44a1.8 1.8 0 01.62 1.41q0 .67-.34 1.16t-.97.76-1.52.26a4 4 0 01-1.53-.27 2.3 2.3 0 01-1.02-.8q-.36-.53-.37-1.31h1.48q.03.36.21.6.2.25.5.37.32.12.72.12.38 0 .68-.11.28-.11.45-.32.16-.2.16-.46a.6.6 0 00-.15-.41 1 1 0 00-.42-.29q-.27-.12-.67-.21l-.8-.2a3.3 3.3 0 01-1.44-.7 1.6 1.6 0 01-.53-1.28q0-.66.35-1.15.36-.5.98-.78.64-.27 1.42-.27.8 0 1.42.27.6.29.94.78.34.48.35 1.14zm6.56 0a1 1 0 00-.37-.67q-.31-.24-.88-.24-.37 0-.63.11a1 1 0 00-.4.29.7.7 0 00-.13.42q0 .2.08.34t.25.25q.16.1.37.18t.45.13l.65.15q.47.12.87.29t.7.44a1.8 1.8 0 01.61 1.41q0 .67-.34 1.16-.33.48-.97.76-.63.26-1.51.26a4 4 0 01-1.54-.27 2.3 2.3 0 01-1.01-.8q-.36-.53-.38-1.31h1.49q.02.36.2.6.2.25.5.37.32.12.72.12t.68-.11q.3-.11.45-.32.16-.2.16-.46a.6.6 0 00-.15-.41 1 1 0 00-.42-.29q-.27-.12-.67-.21l-.79-.2a3.3 3.3 0 01-1.45-.7 1.6 1.6 0 01-.53-1.28q0-.66.35-1.15.36-.5.98-.78.63-.27 1.43-.27t1.4.27.95.78q.34.48.35 1.14z"
      />
    </svg>
  );
}

SvgPicCirclePaymentSsSelected.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgPicCirclePaymentSsSelected.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => (
  <SvgPicCirclePaymentSsSelected svgRef={ref} {...props} />
));
export default ForwardRef;
